import {
  generateXLSX,
  fetchMenteeRecords,
  fetchMentorRecords,
} from '../../helpers';
import { MentorsService, MenteeService } from '../../services';

export const exportMentee = async () => {
  try {
    const data = await fetchMenteeRecords();
    generateXLSX(data, 'mentee_responses', MenteeService.getQuestions);
  } catch (e) {
    console.error(e);
  }
};

export const exportMentor = async () => {
  try {
    const data = await fetchMentorRecords();
    generateXLSX(data, 'mentor_responses', MentorsService.getQuestions);
  } catch (e) {
    console.error(e);
  }
};
